import { render, staticRenderFns } from "./OldVersion_WarehouseDetails.vue?vue&type=template&id=6b213fca&scoped=true"
import script from "./OldVersion_WarehouseDetails.vue?vue&type=script&lang=js"
export * from "./OldVersion_WarehouseDetails.vue?vue&type=script&lang=js"
import style0 from "./OldVersion_WarehouseDetails.vue?vue&type=style&index=0&id=6b213fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b213fca",
  null
  
)

export default component.exports